module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-88.73f2762b.svg";